module.exports = __webpack_public_path__ + "media/images/mailer/thumb_logo-17dc268ffdc7079f2ff9e3f80e70ff84.jpg";